import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map, List } from 'immutable';
import moment from 'moment';
import classNames from 'classnames';
import { intersection } from 'lodash';
import Icon from '../Icon/Icon';
import { observer } from 'mobx-react';
import { observable, makeObservable } from 'mobx';

@observer
class BetslipButtons extends React.Component {
    static propTypes = {
        accountId: PropTypes.number,
        isStakeEmpty: PropTypes.bool,
        isFPwithNoPrice: PropTypes.bool,
        emptyLegInvalid: PropTypes.bool,
        isExpired: PropTypes.bool,
        isSplitted: PropTypes.bool,
        isReferred: PropTypes.bool,
        referredStatus: PropTypes.string,
        possibleBetStatus: PropTypes.string,
        offeredBetslip: ImmutablePropTypes.map,
        changedBets: ImmutablePropTypes.map,
        traderAssign: ImmutablePropTypes.map,
        permissions: ImmutablePropTypes.map,
        isReferralFreeBet: PropTypes.bool,
        totalFreebetAmount: PropTypes.number,
        shouldShowFreeBetButton: PropTypes.bool,
        betslipUpdated: PropTypes.bool,

        onPlaceBet: PropTypes.func.isRequired,
        onAcceptReferredBetslip: PropTypes.func.isRequired,
        onRejectReferredBetslip: PropTypes.func.isRequired,
        onOfferReferredBetslip: PropTypes.func.isRequired,
        onClearReferredBetslip: PropTypes.func.isRequired,
        onClearOfferReferredBetslip: PropTypes.func.isRequired,
        onAssignTrader: PropTypes.func,
        getPossibleBets: PropTypes.func
    };

    @observable queueAction = undefined;

    constructor(props, context) {
        super(props, context);
        this.state = {
            emptyStakeWarning: false,
            emptyPriceWarning: false,
            emptyLegInvalid: false,
            offeredExpired: props.isExpired,
            secs: 0
        };
        makeObservable(this);
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (props.referredStatus === 'request') {
            clearTimeout(this.timeout);
        }

        if (!props.isStakeEmpty) {
            this.setState({
                //  ...this.state,
                emptyStakeWarning: false
            });
        }

        if (!props.isFPwithNoPrice ) {
            this.setState({
                // ...this.state,
                emptyPriceWarning: false
            });
        }

        const expiresAt = props.offeredBetslip.getIn([ 'items', 'expiresAt' ]);
        const secs = moment(expiresAt).diff(moment(), 'seconds');

        this.state = {
            //  ...this.state,
            offeredExpired: expiresAt ? secs <= 0 : props.isExpired
        };

        if (props.offeredBetslip.get('state') === 'FINISHED'){
            clearInterval(this.interval);
            this.interval = setInterval(() => this.tick(), 300);
        }
    }

     componentDidUpdate(){
        const { onOfferReferredBetslip, multiples, bets, selectionsPlacementErrors, possibleBetStatus, totalStake, potentialReturns } = this.props;
        const codesPlacementErrors = this.getCodesErrors(selectionsPlacementErrors) || [];

        if (possibleBetStatus === "FINISHED"){
            if (codesPlacementErrors.indexOf("suspended") !== -1 ) return;
            if (this.queueAction === "OfferBet"){
                this.queueAction = '';
                setTimeout(() => {
                    this.props.onOfferReferredBetslip(this.props.bets, this.props.legs, totalStake, potentialReturns);
                }, 0);
            }

        }

    }

    componentWillUnmount() {
        clearInterval(this.interval);
        clearTimeout(this.timeout);
    }

    getCodesErrors(selectionsPlacementErrors){
       return selectionsPlacementErrors.map( selectionPlacementError => selectionPlacementError.code );
    }

    offerBetslip() {
        const { getPossibleBets, bets, selected, legs } = this.props;

        this.queueAction = "OfferBet";

        this.setState(() => ({
            // ...this.state,
            offeredExpired: false,
        }), () => {
            getPossibleBets(selected || [], bets, legs);
        });
    }

    acceptBetslip(value) {
        this.props.onAcceptReferredBetslip(value);

        if (!value) {
            const { getPossibleBets, bets, selected, legs } = this.props;

            this.queueAction = "AcceptBet";
            getPossibleBets(selected || [], bets, legs);
        }
    }

    placeBet(value, freebet) {
        const { onPlaceBet, isStakeEmpty, isFPwithNoPrice, emptyLegInvalid } = this.props;
        const isFreebet = freebet === 'freebet';

        this.setState({
            emptyStakeWarning: isStakeEmpty,
            emptyPriceWarning: isFPwithNoPrice,
            isFreebet
        });

        if (!isStakeEmpty && !emptyLegInvalid && !isFPwithNoPrice) {
            onPlaceBet( value, value === 'override' && this.state.isFreebet || isFreebet );
        }
    }

    tick() {
        const expiresAt = this.props.offeredBetslip.getIn([ 'items', 'expiresAt' ]);
        const secs = moment(expiresAt).diff(moment(), 'seconds');

        this.setState({
            secs: secs > 0 ? secs : 0,
            offeredExpired: secs === 0
        });

        if (secs === 0) {
            clearInterval(this.interval);
            this.timeout = setTimeout(() => {
                this.props.onClearReferredBetslip();
                /* This function clear offer object from push */
                this.props.onClearOfferReferredBetslip();
                /* This function clear offer object from api reques*/
            }, 5000);
        }
    }

    render() {
        const { offeredExpired, emptyStakeWarning, emptyPriceWarning } = this.state;
        const { offeredBetslip, onRejectReferredBetslip, changedBets, onAssignTrader, emptyLegInvalid,
            isExpired, isSplitted, isReferred, referredStatus, traderAssign, accountId, permissions, placementStatus,
            selectionsPlacementErrors, bets, multiples, betslipUpdated,
            errors, possibleBetStatus, isReferralFreeBet, totalFreebetAmount,
            acceptReferredStatus, shouldShowFreeBetButton } = this.props;

        const queueAction = this.queueAction;

        // TODO: To be improved and based on only one criteria to check if is freebet
        let freebetExceedsAmount = possibleBetStatus !== 'FINISHED';

        const minOdds = bets.concat( multiples ).reduce( (acc, bet) => {
            if ( !bet.get( 'stakePerLine' ) ) return acc;

            if ( !freebetExceedsAmount ) {
                freebetExceedsAmount = !bet.get( 'freebetCredits' );
            }

            const minimum = (bet.get( 'freebetRemarks' ) || List()).find( remark =>
                remark.get( 'code' ) === 'minimum' && remark.getIn( [ 'details', 'minimum' ] )
            );

            if ( minimum ) {
                const minOdd = minimum.getIn( [ 'details', 'minimum' ] );

                return !acc ? minOdd : Math.min( acc, minOdd );
            }

            return acc;
        }, 0 );

        const betReferralStatuses = (
            <span className={classNames([ 'btn', {
                'btn--error': referredStatus === 'reject' || (offeredExpired && referredStatus !== 'reject'),
                'btn--success': referredStatus === 'accept' || (referredStatus === 'offered' && !offeredExpired)
            } ]) }>
                { offeredExpired && referredStatus !== 'reject' ? 'BetExpired' : void 0 }
                { referredStatus === 'reject' ? 'Bet was rejected' : void 0 }
                { referredStatus === 'accept' ? 'Bet was accepted' : void 0 }
                { referredStatus === 'offered' && !offeredExpired ? 'Bet offered' : void 0 }
            </span>
        );

        const detectedChanges = changedBets.filter(x => x.get('price'));
        const codesPlacementErrors = this.getCodesErrors(selectionsPlacementErrors) || [];

        const disabledAcceptBet = acceptReferredStatus === "IN_PROGRESS" && queueAction === "AcceptBet";

        const acceptReferralButton = detectedChanges.size > 0 ||
        ( acceptReferredStatus !== "IN_PROGRESS" && acceptReferredStatus !=='ERROR' && queueAction === "AcceptBet" && possibleBetStatus === "FINISHED" && permissions.get('betting/bet-placement-override')) ?
            (<button disabled={betslipUpdated || disabledAcceptBet} className='btn' onClick={this.acceptBetslip.bind(this, true)}>
                Override & accept bet
                </button>) :
            (<button disabled={betslipUpdated || disabledAcceptBet} className='btn' onClick={this.acceptBetslip.bind(this, false)}> Accept bet </button>);

        const codesErrors = errors.map( err => typeof err.get === 'function' && err.get('resource'), Map()).toArray();
        const offerErrors = offeredBetslip.get('state') === 'ERROR';

        const opts = {};
        if ( isReferralFreeBet || intersection(codesPlacementErrors,["suspended", "resulted"]).length > 0 || codesErrors.indexOf("Wallet") !== -1) {
            opts['disabled'] = 'disabled';
            opts['className'] = 'btn btn--disabled';
        } else {
            opts['className'] = 'btn';
        }

        const betReferralActions = (
            <div className={ classNames({
                'not-permitted': !this.props.permissions.get('betting/bet-referral-processing')
            }) }>
                { !isSplitted ? acceptReferralButton : void 0 }
                <button onClick={ this.offerBetslip.bind(this)} {...opts} > Offer bet </button>
                <button className='btn' onClick={ onRejectReferredBetslip }> Reject bet </button>
            </div>
        );

        if (traderAssign && traderAssign.get('id') !== accountId && isReferred) {
            return null;
        }

        if (!traderAssign
                && isReferred
                && referredStatus !== "offered"
                && referredStatus !== "accept"
                && referredStatus !== "reject") {
            return (
                <div>
                    <button className='btn' onClick={ onAssignTrader }> Assign me to bet referral </button>
                </div>
            );
        }

        if (isReferred) {
            return (
                <div>
                    { ((!offeredBetslip.get('state') || offeredBetslip.get('state') === 'IN_PROGRESS') && !isExpired) || offerErrors ? betReferralActions : betReferralStatuses }
                </div>
            );
        }

        let emptyStakeWarningBox;
        if (emptyStakeWarning) {
            emptyStakeWarningBox = (
                <span className='btn btn--warning'>
                    You cannot place bet { '\n' } without stake
                </span>
            );
        }

        //emptyPriceWarningBox
        let emptyPriceWarningBox;
        if (emptyPriceWarning) {
            emptyPriceWarningBox = (
                <span className='btn btn--warning'>
                    You cannot place bet { '\n' } without price
                </span>
            );
        }

        let invalidEmptyLegWarningBox;
        if (emptyLegInvalid) {
            invalidEmptyLegWarningBox = (
                <span className='btn btn--error btn--error--small'>
                    Selection and event name and sport { '\n' } for empty leg should be filled in
                </span>
            );
        }
        const classes = classNames({
            'buttons--override': changedBets.size > 0
        });

        const allowFreeBet = totalFreebetAmount > 0;

        const freeBetLimitMessage = !shouldShowFreeBetButton && allowFreeBet && (
            <div className='info-message arrow-top' key='free-bet-limit-message'>
                <Icon name='infoLine' />
                {
                    minOdds ? `Minimum Odds on free bets are ${minOdds}` :
                        freebetExceedsAmount && possibleBetStatus === 'FINISHED' ?
                            'Lower stake to use free bet credits' :
                                'Returns exclude stake'
                }
            </div>
        );

        const buttonsClassNames = !shouldShowFreeBetButton && allowFreeBet ? 'col-6' : 'col-12';
        const placeBetButtons = [
            <div className='row' key='place-bet-buttons'>
                {
                    allowFreeBet && !shouldShowFreeBetButton && (
                        <div className={ buttonsClassNames }>
                            <button key='place-free-bet'
                                    className={ classNames( 'btn',
                                        {
                                            'btn--disabled': freebetExceedsAmount,
                                            'in-progress': possibleBetStatus !== 'FINISHED'
                                        }
                                    ) }
                                    onClick={ () => !freebetExceedsAmount && this.placeBet( null, 'freebet' ) }
                                    data-test='button-free-bet'
                            >
                                <Icon name='gift'/>Free bet
                            </button>
                        </div>
                    )
                }

                <div className={ buttonsClassNames }>
                    <button className='btn' onClick={ this.placeBet.bind(this)} key='place-bet' data-test='button-cash-bet'>Cash bet</button>
                </div>
            </div>,
            freeBetLimitMessage
        ];

        return (
            <div className={ classes }>
                { invalidEmptyLegWarningBox }
                { emptyStakeWarningBox }
                { emptyPriceWarningBox }
                { placementStatus === "ERROR" && !permissions.get('betting/bet-placement-override') ? <button className='btn' disabled='true'> PERMISSION REQUIRED </button> : (
                    detectedChanges.size > 0 || permissions.get('betting/bet-placement-override') && placementStatus === "ERROR" ? (
                        <>
                            <button className='btn' onClick={ this.placeBet.bind(this, 'override') } data-test='button-override-and-place-bet'>
                                Override & place bet
                            </button>
                            <button className={ classNames( 'btn',
                                        {
                                            'btn--disabled': freebetExceedsAmount,
                                        }
                                    ) } onClick={ !freebetExceedsAmount ? this.placeBet.bind(this, 'override', 'freebet') : null } data-test='button-override-and-place-freebet'>
                                Override & place freebet
                            </button>
                        </>
                    ) : placeBetButtons )
                }
            </div>
        );
    }
}

export default BetslipButtons;
